import React from 'react';

function Loader({
  className = '',
  label = 'Chargement...',
  size = 'medium',
}) {
  return (
    <div
      className={[
        'custom-loader',
        `custom-loader--${size}`,
        className,
      ].filter(Boolean).join(' ')}
      role="status"
      aria-live="polite"
    >
      <span className="custom-loader__spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export default Loader;
